export default {
    ABSTRACT: 'Аннотация',
    ACCESS: 'Доступ',
    ACCESS_TO_DOCUMENT_IS_AVAILABLE_ONLY_FROM_RSL: 'Доступ к документу возможен только внутри РГБ.',
    ADD: 'Добавить',
    ADVANCED_SEARCH: 'Расширенный поиск',
    ADVANCED_SEARCH_HELP: 'Справка о расширенном поиске',
    ALL_FIELDS: 'Все поля',
    ALPHABETICAL_INDEX: 'Алфавитный указатель',
    AND: 'и',
    AND_NOT: 'и не',
    AN_ERROR_OCCURRED_WHILE_ADDING_DOCUMENT_TO_FAVORITES: 'При добавлении документа в избранное возникла ошибка.',
    AN_ERROR_OCCURRED_WHILE_LOADING_THE_DATA: 'Произошла ошибка при попытке загрузить данные.',
    AN_ERROR_OCCURRED_WHILE_PROCESSING_YOUR_REQUEST_BY_THE_SERVER: 'При обработке вашего запроса сервером возникла ошибка.',
    AN_ERROR_OCCURRED_WHILE_REMOVING_THE_DOCUMENT_FROM_FAVORITES: 'При удалении документа из избранного возникла ошибка.',
    AN_ERROR_OCCURRED_WHILE_TRYING_TO_LOG_IN_PLEASE_CONTACT_ADMINISTRATOR: 'При попытке входа возникли проблемы. Обратитесь к администратору.',
    AN_ERROR_OCCURRED_WHILE_TRYING_TO_LOG_IN_THROUGH_UNIFIED_AUTHORIZATION_SYSTEM_PLEASE_CONTACT_ADMINISTRATOR: 'При попытке входа через систему единой авторизации возникли проблемы. Обратитесь к администратору.',
    ARRIVALS: 'Поступления',
    ART_EDITIONS: 'изоиздания',
    AUTHOR: 'Автор',
    AUTHOR_DOCUMENT_TITLE_OR_KEY_WORDS: 'Автор, название документа или ключевые слова',
    BBK_INDEX: 'BBK-код',
    BIBLIOMETRIC: 'Библиометрический',
    BY_AUTHORS: 'По авторам',
    BY_AUTHOR_IN_ASCENDING_ORDER: 'По автору (по возр.)',
    BY_AUTHOR_IN_DESCENDING_ORDER: 'По автору (по убыв.)',
    BY_DATE_OF_RECEIPT_IN_ELECTRONIC_CATALOGUE_IN_ASCENDING_ORDER: 'По дате поступл-я в ЭК (по возр.)',
    BY_DATE_OF_RECEIPT_IN_ELECTRONIC_CATALOGUE_IN_DESCENDING_ORDER: 'По дате поступл-я в ЭК (по убыв.)',
    BY_DATE_OF_RECEIPT_IN_ELECTRONIC_LIBRARY_IN_ASCENDING_ORDER: 'По дате поступл-я в ЭБ (по возр.)',
    BY_DATE_OF_RECEIPT_IN_ELECTRONIC_LIBRARY_IN_DESCENDING_ORDER: 'По дате поступл-я в ЭБ (по убыв.)',
    BY_PUBLICATION_DATE_IN_ASCENDING_ORDER: 'По году публикации (по возр.)',
    BY_PUBLICATION_DATE_IN_DESCENDING_ORDER: 'По году публикации (по убыв.)',
    BY_RELEVANCE: 'По релевантности',
    BY_TITLE: 'По заглавиям',
    BY_TITLE_ASC: 'По названию (по возр.)',
    BY_TITLE_DESC: 'По названию (по убыв.)',
    CANCEL_REQUEST_FOR_DIGITIZING: 'Отменить заявку оцифровки',
    CATALOGUE: 'Каталог',
    CATALOGUES: 'Каталоги',
    CATALOGUE_CARD: 'Карточка',
    CATALOGUE_OF_RECORDS: 'Каталог записей',
    CHOOSE: 'выбрать',
    CHOOSE_DISCIPLINE: 'Выбор специальностей',
    CHOOSE_LANGUAGE: 'Выбор языка',
    CHOOSE_LANGUAGES: 'Выбор языков',
    CLEAR: 'Очистить',
    CLEAR_ALL_FILTERS: 'очистить все фильтры',
    CLOSE: 'Закрыть',
    COLLECTION: 'Коллекция',
    COMMENTS: 'Примечание',
    CONFIRM: 'Подтвердить',
    CONSISTS_OF: 'Состоит из',
    CONTENT: 'Содержание',
    CONTENTS: 'Состав',
    CONTINUE: 'Продолжить',
    COPIES_OF_THE_DOCUMENT_AVAILABLE_FOR_THE_ELECTRONIC_ORDER_WERE_NOT_FOUND: 'Не найдены доступные для электронного заказа экземпляры документа.',
    DATABASE_ACCESS: 'Доступ к базе данных',
    DATABASE_ACCESS_ON_THE_PLATFROM_OF_RUSSIAN_ARCHIVE_OF_ACADEMIC_JOURNALS: 'Доступ к базе данных на платформе российского архива научных журналов',
    DATABASE_ACCESS_ON_THE_PUBLISHER_PLATFORM: 'Доступ к базе данных на платформе издателя',
    DATE_OF_RECEIPT_IN_ELECTRONIC_CATALOGUE: 'Дата поступления в ЭК',
    DATE_OF_RECEIPT_IN_THE_ELECTRONIC_LIBRARY: 'Дата поступления в ЭБ',
    DATE_OF_RECEIPT_IN_THE_FUND: 'Дата поступления в фонд',
    DECLINE: 'Отказаться',
    DEPOSITED_DOCUMENTS: 'Депонированные документы',
    DESCRIPTION: 'Описание',
    DEVELOPED_IN: 'разработано в',
    DID_YOU_MEAN_SEARCH_FOR_WORD: 'Возможно, вы имели в виду {word}?',
    DIGITAL: 'Цифровой',
    DIGITAL_COPY: 'Электронный адрес',
    DIGITAL_DOCUMENTS_FUND: 'Фонд электронных документов',
    DIGITAL_LIBRARY_COLLECTIONS: 'Коллекции ЭБ',
    DISCIPLINE: 'Специальность',
    DISSERTATION: 'диссертация',
    DISSERTATION_ABSTRACT: 'автореферат',
    DOCUMENT: 'документ',
    DOCUMENT_IN_THE_BRANCH: 'документ в филиале',
    DOCUMENT_IS_IN_LIMITED_ACCESS: 'Документ находится в ограниченном доступе.',
    DOCUMENT_IS_FREELY_AVAILABLE: 'Документ в находится свободном доступе.',
    DOCUMENT_IS_TEMPORARILY_UNAVAILABLE: 'Документ временно недоступен для просмотра.',
    DOCUMENT_WAS_ADDED_TO_FAVORITES: 'Документ добавлен в избранное.',
    DOCUMENT_WAS_REMOVED_FROM_FAVORITES: 'Документ удален из избранного.',
    DOCUMENT_WITH_THIS_IDENTIFIER_WAS_NOT_FOUND: 'Документ с указанным идентификатором не найден.',
    DOWNLOAD_MARC21_RECORD: 'Скачать marc21-запись',
    DOWNLOAD_RUSMARC_RECORD: 'Скачать rusmarc-запись',
    DOWNLOAD_DOCUMENT: 'Скачать документ',
    EDITION: 'Издание',
    ELECTRONIC_ORDER: 'Электронный заказ',
    ELECTRONIC_ORDER_FOR_THE_DOCUMENT_WAS_SUCCESSFULLY_CONFIRMED: 'Электронный заказ на документ был успешно подтверждён.',
    ELECTRONIC_RESOUCE: 'Электронный ресурс',
    ELEVATE: 'Поднять вверх',
    ENTER_DISCIPLINE: 'Введите специальность',
    ENTER_IDENTIFIER: 'Введите идентификатор',
    ENTER_LANGUAGE: 'Введите язык',
    ENTER_PUBLISHER: 'Введите издателя',
    ENTER_SEARCH_PHRASE: 'Введите фразу для поиска',
    ENTER_VALUE: 'Введите значение',
    EXTERNAL_RESOURCES: 'Внешние ресурсы',
    FAVORITES: 'Избранное',
    FILE_NOT_FOUND: 'Файл не найден',
    FILL_IN_ALL_THE_REQUIRED_FIELDS: 'Заполните необходимые поля:',
    FREE: 'Свободный',
    FREE_ACCESS: 'открытый доступ',
    FULL_TEXT: 'Полнотекстовый',
    GENERAL_ELECTRONIC_CATALOGUE: 'Единый электронный каталог',
    GO_TO_AUTOABSTRACT: 'Перейти к автореферату',
    GO_TO_DISSERTATION: 'Перейти к диссертации',
    GO_TO_HOMEPAGE: 'Перейти на главную страницу',
    HELP: 'Справка',
    HIDE: 'скрыть',
    HIGHER_ATTESTATION_COMMISION_DISCIPLINES: 'Специальности ВАК',
    IDENTIFIER_OF_THE_DOCUMENT: 'Идентификатор документа',
    IMPRINT: 'Выходные данные',
    INCORRECT_FILTER_DATA: 'Переданы некорректные данные фильтров.',
    INCORRECT_QUERY: 'Некорректный запрос.',
    INCORRECT_QUERY_PARAMETERS: 'Переданы некорректные параметры запроса.',
    INTERNAL_ERROR: 'Внутренняя ошибка сервиса.',
    INVALID_ID_FORMAT: 'Неверный формат идентификатора.',
    INVALID_RECORD_IDENTIFIER: 'Передан некорректный идентификатор документа.',
    INVALID_REQUEST_TYPE: 'Некорректный тип запроса.',
    KEY_WORDS: 'Ключевые слова',
    LANGUAGE: 'Язык',
    LANGUAGES: 'Языки',
    LICENSE: 'Лицензионный',
    LIMITED_ACCESS: 'доступ ограничен',
    LIMIT_OF_QUERIES_FOR_DOWNLOAD_WAS_EXCEEDED_PLEASE_TRY_LATER: 'Превышен лимит запросов на загрузку документа. Пожалуйста, попробуйте позже.',
    LITRES: 'Литрес',
    LOADING: 'загрузка...',
    LOGIN: 'Вход в систему',
    LOGOUT: 'Выйти',
    MARK_AS_DIGITIZED: 'Пометить оцифрованным',
    MATCHES_FOUND: 'Найденные совпадения',
    MORE: 'ещё',
    NAME_OF_A_PERSON: 'Имя лица',
    NOTES: 'ноты',
    NO_DATA_AVAILABLE: 'Данные отсутствуют.',
    NO_DATA_IS_AVAILABLE: 'Нет данных для отображения.',
    NO_MATCHES_WERE_FOUND_FOR_YOUR_QUERY_TRY_TO_CHANGE_THE_QUERY: 'По вашему запросу ничего не найдено. Попробуйте изменить запрос.',
    NO_SELECTED_ITEMS: 'Нет выбранных элементов',
    N_SEC: '{n} сек.',
    OR: 'или',
    ORDER: 'Заказать',
    ORDER_FROM_AFFILIATED_BRANCH: 'заказ из филиала',
    ORDER_FROM_STORAGE: 'заказ из хранилища',
    ORDER_IN_SPECIALIZED_DEPARTMENT: 'заказ в специализированном отделе',
    ORDER_USING_ALEPH: 'заказ через Алеф',
    OR_ENTER_IDENTIFIER_OF_THE_DOCUMENT: 'Или введите идентификатор документа:',
    PAGE: 'стр',
    PAGE_N: 'стр. {number}',
    PAGE_NOT_FOUND: 'Страница не найдена',
    PASSWORD: 'Пароль',
    PERIODICAL: 'Периодика',
    PERSONALIA: 'Персоналия',
    PHYSICAL_DESCRIPTION: 'Физическое описание',
    PLACE_OF_PUBLICATION: 'Место издания',
    PLEASE_FILL_IN_THE_FOLLOWING_FIELDS_TO_LOGIN: 'Пожалуйста, заполните нижеприведенные поля для того, чтобы войти в систему:',
    PREVIEW_UNAVAILABLE: 'Недоступно для просмотра',
    PROFESSIONAL_SEARCH: 'Профессиональный поиск',
    PROFILE: 'Профиль',
    PUBLICATION_DATE: 'Год издания',
    PUBLISHED_BY: 'Изданы по',
    PUBLISHED_FROM: 'Изданы с',
    PUBLISHER: 'Издатель',
    PUBLISHING_HOUSE: 'Издательство',
    PUT_DOWN: 'Опустить вниз',
    QUOTATIONS_FROM_THE_TEXT: 'Цитаты из текста',
    READ: 'Читать',
    REFERENCE_BIBLIOGRAPHIC: 'Реферативно-библиографический',
    REGISTRATION_NUMBER: 'Регистрационный номер',
    REGULATIONS: 'устав',
    REMEMBER: 'Запомнить',
    REQUEST_CANNOT_BE_SUBMITTED_USER_IS_UNDEFINED: 'Подача заявки невозможна: пользователь не определён.',
    REQUEST_FOR_DIGITIZING_THIS_DOCUMENT_HAS_ALREADY_BEEN_REGISTERED_IN_THE_SYSTEM: 'Запрос на оцифровку этого документа уже зарегистрирован в системе.',
    REQUEST_FOR_DIGITIZING_THIS_DOCUMENT_HAS_BEEN_ACCEPTED: 'Заявка на оцифровку документа была принята.',
    REQUEST_FOR_DIGITIZING_THIS_DOCUMENT_HAS_BEEN_CANCELLED: 'Заявка на оцифровку документа была отменена.',
    REQUEST_LIMIT_EXCEEDED_PLEASE_TRY_LATER: 'Превышен лимит запросов. Пожалуйста, попробуйте позже.',
    REQUIRED_COPY_OF_THE_DOCUMENT_IS_NOT_FOUND_OR_IS_NOT_AVAILABLE_FOR_ORDER: 'Указанная копия документа не обнаружена или недоступна для заказа.',
    RESOURCE_TYPE: 'Тип ресурса',
    RESPONSIBILITY: 'Сведения об ответственности',
    RESTRICTED: 'Ограниченный',
    RESULTS: 'результаты',
    RESULTS_INCLUDE_THE_FOLLOWING_SYNONYMS: 'В результатах участвуют синонимы слов:',
    RETRIEVED_IN_ELECTRONIC_CATALOGUE: 'Поступило в ЭК',
    RETRIEVED_IN_ELECTRONIC_CATALOGUE_BY: 'Поступили в ЭК по',
    RETRIEVED_IN_ELECTRONIC_CATALOGUE_FROM: 'Поступили в ЭК с',
    RETRIEVED_IN_ELECTRONIC_LIBRARY: 'поступило в ЭБ',
    RETRIEVED_IN_ELECTRONIC_LIBRARY_BY: 'Поступили в ЭБ по',
    RETRIEVED_IN_ELECTRONIC_LIBRARY_FROM: 'Поступили в ЭБ с',
    RSL: 'РГБ',
    RUSSIAN_STATE_LIBRARY: 'Российская<br>государственная<br>библиотека',
    SEARCH: 'Поиск',
    SEARCH_FIELDS: 'Поисковые поля',
    SEARCH_PHRASE: 'искать фразу',
    SEARCH_PREFIX: 'искать префикс',
    SEARCH_STEMMING: 'с учётом морфологии',
    SEARCH_WITHOUT_STEMMING: 'без учёта морфологии',
    SERIES: 'Серия',
    SERVICES: 'Услуги',
    SHOW: 'показать',
    SOME_OF_IDENTIFIERS_HAVE_AN_INCORRECT_FORMAT: 'Некоторые из переданных идентификаторов имеют некорректный формат.',
    SORTING: 'Сортировка',
    STATISTICAL_DATABASE: 'Статистическая база данных',
    STORAGE_CODE: 'Шифр хранения',
    STORAGE_LOCATION: 'Места хранения',
    SUBJECT: 'Тема',
    THEME: 'Тематика',
    THE_DOCUMENT_IS_ACCESSIBLE_FROM_ANYWHERE_THROUGH_THE_SECURE_VIEWER: 'Документ доступен из любого места через программу защищённого просмотра.',
    THE_DOCUMENT_IS_PROTECTED_BY_COPYRIGHT_FULL_TEXT_IS_AVAILABLE_IN_RSL_AND_VIRTUAL_READING_ROOMS: 'Документ охраняется авторским правом. Полный текст доступен в РГБ и виртуальных читальных залах.',
    THE_ENTRY_IS_NOT_FOUND: 'Запись не найдена.',
    THE_OPTION_TO_SUBMIT_A_REQUEST_IS_OFF: 'Возможность подачи заявки отключена.',
    THE_QUERY_REPLACED_FAILED_A_SEARCH_WAS_CONDUCTED_FOR_NEW: 'Запрос {replaced} не дал результатов. Произведён поиск по запросу {new}.',
    THE_SERVICE_OF_ELECTRONIC_ORDER_IS_TEMPORARILY_UNAVAILABLE: 'Сервис электронного заказа временно недоступен.',
    THE_SPECIFIED_DOCUMENT_HAS_ALREADY_BEEN_DIGITIZED: 'Указанный документ уже оцифрован.',
    THE_SPECIFIED_RESOURCE_WAS_NOT_FOUND_IN_THE_SYSTEM: 'Указанный ресурс в системе не найден.',
    THIS_EMAIL_ADDRESS_IS_ALREADY_IN_USE_IN_THE_SYSTEM: 'Этот адрес электронной почты уже используется в системе.',
    THIS_USERNAME_IS_ALREADY_IN_USE: 'Этот логин уже занят.',
    TITLE: 'Название',
    TO_MAIN: 'На главную',
    TO_ORDER_A_DOCUMENT_YOU_MUST_BE_AUTHORIZED_IN_THE_SYSTEM_AND_HAVE_THE_CORRECT_NUMBER_OF_THE_LIBRARY_CARD: 'Для создания заказа на документ необходимо быть авторизованным в системе и иметь корректный номер читательского билета.',
    TO_USE_THE_SERVICE_OF_ELECTRONIC_ORDER__EORDERGETREADERNUMBERLINK: 'Чтобы воспользоваться услугой электронного заказа, {eorderGetReaderNumberLink}.',
    UNAVAILABLE: 'недоступен',
    UNDEFINED_KEY_0: '{n, plural, one{# пользователя} other{# пользователей}}',
    UNDEFINED_KEY_1: '{n, plural, one{заявлен на оцифровку # документ} many{заявлено на оцифровку # документов} other{заявлено на оцифровку # документа}}',
    UNDEFINED_KEY_2: 'Можно использовать только буквы латинского алфавита, цифры, символы \'-\' и \'_\'.',
    UNDEFINED_KEY_3: 'Этот тег уже используется в другой статье на том же языке.',
    UNDIGITIZED_DOCUMENTS: 'Неоцифрованные документы',
    UPDATING_THE_DATA: 'Данные обновляются...',
    UPLINK: 'Входит в',
    USERNAME: 'Логин',
    VIEW: 'Смотреть',
    VIEW_RECORD: 'Просмотр записи',
    VIEW_THE_RESULTS_OF_AN_EXTERNAL_RESOURCE: 'Просмотр результатов внешнего ресурса',
    VOLUME: 'Том',
    VOTE_FOR_DIGITIZING: 'Проголосовать за оцифровку',
    YOUR_REQUEST_FOR_DIGITIZING_THIS_DOCUMENT_WAS_NOT_PREVIOUSLY_REGISTERED: 'В системе не зарегистрировано запроса на оцифровку данного документа от Вашего лица.',
    YOU_HAVE_REACHED_THE_LIMIT_OF_APPLICATIONS__N_TIMES_PER_DAY__PLEASE_TRY_AGAIN_LATER: 'Вы исчерпали лимит заявок ({n} в сутки). Попробуйте позже.',
    YOU_HAVE_TO_GET_A_LIBRARY_CARD_OF_RSL: 'получите читательский билет РГБ',
    YOU_HAVE_TO_LOGIN_TO_ADD_DOCUMENT_TO_FAVORITES: 'Вам необходимо войти, чтобы добавить документ в избранное.',
    YOU_HAVE_TO_LOGIN_TO_DOWNLOAD_THIS_FILE: 'Вам необходимо войти, чтобы скачать этот файл.',
    YOU_HAVE_TO_LOGIN_TO_ORDER_THIS_DOCUMENT: 'Вам необходимо войти, чтобы совершить электронный заказ этого документа.',
    // Здесь начинаются переводы, которых не было в изначальном файле
    LOGIN_SIMPLE: 'Вход',
    OPEN_SEARCH: 'Открыть поиск',
    OPEN_MENU: 'Открыть меню',
    SERVICES_SIMPLE: 'Сервисы',
    REFERENCE_INFORMATION: 'Справочная информация',
    HIDE_OR_SHOW_LIST: 'Закрыть / Показать',
    CHOOSE_ALL: 'Выбрать все',
    ACCESS_FREE: 'Открытый доступ',
    ACCESS_LIMITED: 'Ограниченный доступ',
    CHOOSE_FROM_THE_DIRECTORY: 'Выбрать из справочника',
    REMOVE_FILTER: 'Удалить фильтр',
    SYSTEM_NUMBER: 'Системный №',
    SEE_RELATED_DOCUMENTS: 'Посмотреть связанные документы',
    QUOTES_FROM_TEXT: 'Цитаты из текста',
    ADD_TO_FAVORITES: 'Добавить в избранное',
    REMOVE_FROM_FAVORITES: 'Убрать из избранного',
    MORE_INFO: 'Дополнительная информация',
    CLOSE_MODAL_WINDOW: 'Закрыть модальное окно',
    CHOOSED_LANGUAGES: 'Выбранные языки',
    CHOOSED_SPECIALITIES: 'Выбранные специальности',
    PUBLISHED_IN: 'Изданные в',
    // New
    VIEWED_DOCUMENTS: 'Просмотренные документы',
    MARKERS: 'Закладки',
    NEGATIVE: 'Негатив',
    OPEN_DOCUMENT: 'Открыть документ',
    SKETCHES: 'Эскизы',
    ONLINE_VIEWER: 'Просмотр документа',
    CHANGE_VIEW_MODE: 'Изменить режим просмотра',
    NEXT_PAGE: 'Следующая странина',
    LAST_PAGE: 'Последняя страница',
    PREVIOUS_PAGE: 'Предыдущая страница',
    FIRST_PAGE: 'Первая страница',
    ROTATE_LEFT: 'Повернуть против часовой',
    ROTATE_RIGHT: 'Повернуть по часовой',
    FULL_WIDTH: 'На всю ширину',
    FULL_HEIGHT: 'На всю высоту',
    LEFT: 'Влево',
    RIGHT: 'Вправо',
    UP: 'Вниз',
    DOWN: 'Вверх',
    ZOOM_IN: 'Увеличить масштаб',
    ZOOM_OUT: 'Уменьшить масштаб',
    GO_TO_MAIN_PAGE: 'Вернуться на главную страницу',
    GO_TO_PREVIOUS_PAGE: 'Перейти на предыдущую страницу',
    GO_TO_NEXT_PAGE: 'Перейти на следующую страницу',
    HIDE_PANEL_WITH_PREVIEW_PAGES: 'Спрятать панель с превью страниц',
    FIT_PAGE_BY_WIDTH: 'Уместить страницу по ширине',
    FIT_PAGE_BY_HEIGHT: 'Уместить страницу по высоте',
    SCROLL_CURRENT_PAGE: 'Скроллинг текущей страницы',
    SHOW_HIDE_NAVIGATION_PANEL: 'Показать/скрыть панель навигации',
    PAGE_SCALING: 'Масштабирование страницы',
    SEARCH_BY_DOCUMENT: 'Поиск по документу',
    SEARCH_BY_TEXT: 'Поиск по тексту',
    PREVIEW_PAGES_OF_THE_DOCUMENT: 'Уменьшенные страницы документа. Вы можете переходить на нужную страницу просто кликнув на её уменьшенную копию',
    MENU_DESCRIPTION: 'В разделе меню вы можете зайти в личный кабинет, переключить язык или выбрать другой сервис РГБ. На боковой панели доступны разделы, которые помогут упростить работу с просмотром',
    DOWNLOAD_WITHOUT_SPEED_LIMIT: 'Скачать без ограничения скорости',
    DOWNLOAD_NORMALLY: 'Скачать в обычном режиме',
    FOUND: 'Найдено',
    DOCUMENT_DOES_NOT_SUPPORT_SEARCH: 'Документ не поддерживает поиск',
    SHOW_OR_HIDE: 'Свернуть / развернуть',
    TO_WATCH_DOCUMENT_USE_SEARCH: 'Чтобы посмотреть интересующий вас документ, воспользуйтесь поисковой системой',
    YOU_HAVE_NO_BOOKMARKS_TO_ADD_BOOKMARKS_USE_THE_BUTTON_ADD_TO_BOOKMARKS: 'У вас нет закладок! Чтобы добавить закладки воспользуйтесь кнопкой добавить в закладки',
    IN_THE_TOP_TOOLBAR: 'в верхней панели инструментов.',
    ADD_TO_CART: 'Добавить в корзину',
    BOOKMARK: 'Добавить в закладки',
    COMMENT: 'Добавть метку на страницу',
    ORDERS: 'Заказы',
    BACK: 'Вернуться',
    DELETE_ORDER: 'Удалить заказ',
    BASKET: 'Корзина',
    CURRENT: 'Текущие',
    ARCHIVE: 'В архиве',
    ORDER_NUMBER: 'Заказ № ',
    PAGES: ' стр.',
    NOT_CONFIRMED: 'Не подтвержден',
    REPEAT_ORDER: 'Повторить заказ',
    YOU_HAVE_NO_ORDERS: 'В данный момент у вас нет заказов',
    TO_ADD_ORDER: 'Чтобы добавить заказ оформите его в корзине.',
    YOU_HAVE_NO_CURRENT_ORDERS_TO_ADD_ORDER_CHECK_IT_OUT_IN: 'В данный момент у вас нет текущих заказов. Чтобы добавить заказ оформите его в ',
    IN_CART: 'Корзине',
    BY_WIDTH: 'По ширине',
    BY_HEIGHT: 'По высоте'
};
